import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mandatoryFieldFormLabel'
})
export class MandatoryFieldFormLabelPipe implements PipeTransform {

  constructor() {}

  transform(isFieldRequired: any): string {
      return isFieldRequired ? '*' : ''
  }
}
